import React from 'react';
import { render } from '@testing-library/react';
import { Frame } from './Frame';
import { BodyText } from '../BodyText';

describe('Frame', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Frame
				header={<BodyText>Header</BodyText>}
				data-auto-sel="automation-selector"
			>
				<BodyText>Page Content</BodyText>
			</Frame>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
